<template>
    <div class="m-fiscanImageSelector">
        <el-dialog
            custom-class="fiscan-image-selector-dialog"
            title="添加职鉴考题"
            :visible="value"
            width="70%"
            top="50px"
            :close-on-click-modal="false"
            :append-to-body="false"
            :modal-append-to-body="false"
            @close="close"
        >
            <div class="dialog-main">

                <div class="left-wrap">
                    <div class="left-wrap-title">查询条件</div>

                    <div class="left-wrap-content">

                        <el-form
                            class="dialog-form"
                            :model="formSearch"
                            label-position="top"
                            size="mini"
                            @submit.native.prevent
                        >
                            <el-form-item :label="$t('res.imgName')">
                                <el-input v-model="formSearch.byName" :placeholder="$t('tip.name')"
                                          @keyup.enter.native="getTable(1)" clearable></el-input>
                            </el-form-item>

                            <el-form-item>
                                <template #label>
                                    <span>{{$t('c.knowledgePoint')}}</span>
                                </template>
                                <el-tree
                                    v-if="value"
                                    ref="fileTree"
                                    :data="treeData"
                                    show-checkbox
                                    node-key="id"
                                    :props="{ children: 'children', label: 'name'}">
                                </el-tree>
                            </el-form-item>

                            <el-form-item label="违禁品数量">
                                <el-radio-group v-model="formSearch.tipCount">
                                    <el-radio-button label="">全部</el-radio-button>
                                    <el-radio-button :label="0">0</el-radio-button>
                                    <el-radio-button :label="1">1</el-radio-button>
                                    <el-radio-button :label="2">2</el-radio-button>
                                    <el-radio-button :label="3">3</el-radio-button>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item>
                                <el-button class="btn-query" @click="getTable(1)" icon="el-icon-search" size="small">
                                    {{ $t('c.query') }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                </div>

                <data-tables-server
                    class="dialog-table"
                    ref="topicTable"
                    :data="dialogTableData"
                    :total="page.total"
                    :table-props="tableProps"
                    :current-page.sync="page.current"
                    :page-size="page.size"
                    :pagination-props="paginationProps"
                    @query-change="onPage"
                    @selection-change="handleSelectionChange"
                    v-viewer="{className: 'viewer-fiscanImage'}"
                >
                    <!-- column checkbox -->
                    <el-table-column
                        type="selection"
                        width="55px"
                        :reserve-selection="true"
                        align="center">
                    </el-table-column>

                    <el-table-column prop="name" label="物品名称" min-width="120px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="productName" label="采集设备" align="center" width="120px"></el-table-column>
                    <el-table-column label="违禁品" align="center" min-width="200px">
                        <template #default="{row}">
                            <ul class="danger-goods" v-if="row.image.marks.length">
                                <li class="danger-item" v-for="item in row.image.marks">
                                    <el-tag type="danger" size="mini">{{item.knowledgeName}}</el-tag>
                                </li>
                            </ul>
                            <span v-else>无</span>
                        </template>
                    </el-table-column>

                    <!-- 图像 -->
                    <el-table-column :label="$t('c.image')" min-width="220px" align="center">
                        <template #default="{row}">
                            <div class="topic-image">
                                <img :src="row.url" alt="image">
                            </div>
                        </template>
                    </el-table-column>
                </data-tables-server>
            </div>

            <div slot="footer" class="dialog-footer">
                <div class="footer-info">
                    已选择 <b>{{selectIds.length}}</b> 项
                </div>
                <div class="footer-buttons">
                    <el-button @click="close" size="medium">{{ $t('c.cancel') }}</el-button>
                    <el-button @click="dialogSave" type="primary" size="medium" :loading="submitLoading">
                        {{ $t('c.save') }}
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            formSearch: {
                byName: '',
                knowledges: [],
                tipCount: ''
            },
            tableData: [],
            tableProps: {
                stripe: true,
                rowKey: row => row.id,
                height: '60vh'
            },
            paginationProps: {
                pageSizes: [50, 100, 300, 500],
            },
            page: {
                current: 1,
                size: 50,
                total: 0,
            },
            treeData: [],

            dialogTableData: [],
            selectIds: [],
            submitLoading: false
        }
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog();
            }
        },
    },

    mounted() {
        this.$api.getFiscanTree().then(res => {
            this.treeData = res.package;
        })
    },

    methods: {
        async initDialog() {
            await this.resetDialog()

            this.getTable(1)
        },

        onPage(q) {
            if (q.type === 'init') return
            this.page.current = q.page
            this.page.size = q.pageSize
            this.getTable()
        },

        getTable(page) {
            if (page) this.page.current = page;

            let checkedNodes = this.$refs.fileTree.getCheckedNodes();
            let nodeArr = [];

            checkedNodes.forEach(ele => {
                let type = ele.type;
                let id = ele.id;
                nodeArr.push(`${type}|${id}`);
            });

            let queryData = {
                ...this.formSearch,
                knowledges: nodeArr,
                PageNO: this.page.current,
                Limit: this.page.size,
            }

            this.$api.queryFiscanPackage(queryData).then(res => {
                this.dialogTableData = res.package
                this.page.total = res.total
            })
        },

        handleSelectionChange(arr) {
            // 这里由于后端分页，切换页码时调用的toggleRowSelection也会触发selecitonChange，导致数据重复
            // 需要过滤掉重复的数据
            let row = []

            arr.forEach(item => {
                if (!row.find(v => v.id === item.id)) {
                    row.push(item)
                }
            })

            this.selectIds = row.map(item => item.id)
        },

        dialogSave() {
            const paperID = this.$route.params.paperId
            const submitData = {
                paperID,
                packageIds: this.selectIds
            }

            this.submitLoading = true

            this.$api.addFiscanImageInPaper(submitData).then(res => {
                const data = res.package

                this.$emit('on-save', data)
                this.close()
            }).finally(() => this.submitLoading = false)
        },

        resetDialog() {
            return new Promise(resolve => {
                // 重置表格和表单
                this.$nextTick(() => {
                    let elTable = this.$refs.topicTable.$refs.elTable
                    elTable.clearSelection()
                    elTable.doLayout()

                    // 初始化查询条件
                    this.formSearch = {
                        byName: '',
                        knowledges: [],
                        tipCount: ''
                    }

                    //this.clearKnowledgeSelect()

                    resolve()
                })
            })
        },

        clearKnowledgeSelect() {
            this.$refs.fileTree.setCheckedKeys([])
        },

        close() {
            this.$emit('input', false)
        },
    },
}
</script>

<style lang="scss">
$side-width: 290px;

.fiscan-image-selector-dialog {
    min-width: 1180px;

    .el-dialog__header {
        border: none;
    }

    .el-dialog__body {
        padding-top: 0;
    }

    .dialog-main {
        display: flex;
        overflow: hidden;
    }

    .left-wrap {
        width: $side-width;
        flex-shrink: 0;
        margin-bottom: 0;
        padding-left: 0;
        padding-right: 30px;
        height: 60vh;
        min-height: 480px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .left-wrap-title {
            height: 46px;
            line-height: 46px;
            padding: 0 20px;
            font-weight: 600;
            background-color: #f4f3f8;
            border: 1px solid #EBEEF5;
        }

        .left-wrap-content {
            position: relative;
            flex: 1;
            overflow: auto;
            border: 1px solid #EBEEF5;
            border-top: none;
        }
    }

    .dialog-form {
        padding: 12px 16px;
        .el-form-item__label {
            padding: 0;
            font-size: 12px;
            font-weight: 600;
        }

        .el-form-item {
            margin-bottom: 12px;
        }

        .btn-query {
            display: block;
            margin: 20px auto 0 auto;
            width: 60%;
        }

        .el-tree-node__label {
            font-size: 12px;
        }
    }

    .dialog-table {
        //flex: 1;
        width: calc(100% - #{$side-width} - 10px);

        thead > tr > th {
            color: #252525;
            background-color: #f4f3f8;
        }
        td {
            padding: 12px 0;
        }
        .cell {
            padding: 0 10px;
        }
        .el-table {
            min-height: 480px;
        }

        .el-pagination {
            text-align: left;
        }

        .topic-image {
            img {
                height: 100px;
                width: auto;
                cursor: pointer;
            }
        }

        .danger-goods {
            display: flex;
            flex-direction: column;

            .danger-item {
                + .danger-item {
                    margin-top: 10px;
                }
            }
        }
    }

    .el-dialog__footer {
        padding: 0;
        border-top: 1px solid #eee;

        .dialog-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 20px;
        }

        .footer-info {
            font-size: 12px;
            b {
                color: $blue;
            }
        }

        .footer-buttons {
            button {
                min-width: 110px;
                margin-left: 16px;
            }
        }
    }
}
</style>
